import ProductCategoriesSelection from './ProductCategoriesSelection'

export default ProductCategoriesSelection
